<div class="card card-custom gutter-b" *ngIf="procedureLoaded">

    <div class="card-header">
        <div class="card-title">
            <div class="mr-3">
                <div *ngIf="procedureData.status === 'Published'">
                    <span class="badge active">{{procedureData.status}}</span>
                </div>
                <div *ngIf="procedureData.status === 'Draft'">
                    <span class="badge draft">{{procedureData.status}}</span>
                </div>
                <div *ngIf="procedureData.status === 'Archived'">
                    <span class="badge archived">{{procedureData.status}}</span>
                </div>
            </div>
            <h3 class="card-label">
                <span translate="PROCEDURES.VIEW_PROCEDURE"></span>
            </h3>
        </div>
        <div class="card-toolbar">
            <button type="button" class="btn-default btn-red d-flex flex-row-reverse"
                    routerLink="/procedures/list">
                <span class="fa fa-times"></span>
            </button>
        </div>
    </div>


    <!--Form Alert Message-->
    <div *ngIf="formSent">
        <div class="col-12 m-0 py-0 px-9">
            <app-form-message [success]="formResponse"
                              [customErrorMessage]="errorMsg"
                              [customSuccessMessage]="successMsg"></app-form-message>
        </div>
        <div class="border-bottom"></div>
    </div>


    <div class="card-body p-0 m-0">
        <div class="col-lg-12 p-0 m-0 p-12">

            <!--Title-->
            <div class="section-wrapper">
                <div class="title title-color">
                    {{procedureData.title}}
                </div>
            </div>

            <!--Author & Date-->
            <div class="section-wrapper mt-3">
                <span class="font-weight-boldest mr-2 main-color">{{procedureAuthor}}</span>
                <span class="mr-2"> - </span>
                <span class="mr-2">
                    <span translate="GENERAL.POSTED_AT"></span>
                    {{procedureData.date}}
                </span>
            </div>

            <!--Categories-->
            <span class="section-wrapper">
                <div *ngFor="let category of procedureData.categories" class="badge-shd gray-label mr-2 mt-2">
                    <span>#{{category}}</span>
                </div>
            </span>

            <!--Description-->
            <div class="col-lg-12 p-0 m-0 py-6 mt-3">
                <div class="pro-text" [innerHtml]="procedureData.description"></div>
            </div>

            <!--Attachments-->
            <div class="col-lg-12 p-0 m-0 mt-3" *ngIf="procedureData.attachments">
                <label class="col-form-label">Uploaded attachments:</label>
                <div *ngFor="let attachment of procedureData.attachments; let i = index">
                    <button class="badge-shd mr-6">
                        <span class="fa fa-image mr-2"></span>
                        <a href="{{attachment.link}}" target="_blank">{{attachment.name}}</a>
                    </button>
                </div>
            </div>

            <!-- Users to Consent -->
            <div class="col-lg-12 p-0 m-0 mt-3"
                 *ngIf="userList.length > 0 && (userRoles | roleChecker : ['ROLE_admin', 'ROLE_super_admin','ROLE_ProceduresFull'])">
                <label class="col-form-label">Users remaining to consent:</label>
                <div class="section-wrapper">
                    <div *ngFor="let user of userList" class="badge-shd mr-2 mt-2">S
                        {{user.firstName}} {{user.lastName}}
                    </div>
                </div>
            </div>

            <!--Signature-->
            <div class="row mt-5">
                <div class="col-12 text-right">
                    <mat-checkbox *ngIf="!checkUserConsent" [(ngModel)]="userConsent"
                                  (change)="addUserToConsent()">
                        <span translate="GENERAL.TAKE_NOTICE"></span>
                    </mat-checkbox>
                    <span class="font-weight-bold" *ngIf="checkUserConsent" translate="GENERAL.AWARE"></span>
                </div>
            </div>
        </div>
    </div>
</div>
